import React from "react";

const Input = ({ type, placeholder, ...others }) => {
  return (
    <input
      {...others}
      className="block w-full text-sm sm:w-64 md:w-72 lg:w-80 pl-4 pr-8 py-2 rounded outline-none border-2 border-transparent focus:border-white bg-white bg-opacity-10 placeholder:text-gray-300 text-white shadow-lg"
      type={type || "text"}
      placeholder={placeholder}
      id={placeholder}
      name={placeholder?.toLowerCase().split(" ").join("")}
    />
  );
};

export default Input;
